import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.html');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-html',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.html/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: hidden;
}

:host * {
  box-sizing: border-box;
}

.feature-guide {
  --ink: #17231d;
  --muted: #68746d;
  --brand: #0c6047;
  --brand-deep: #0a4937;
  --brand-soft: #eaf4ef;
  --focus: #0d7a5a;
  align-items: center;
  background: radial-gradient(circle at 15% 12%, rgba(48, 124, 91, 0.08), transparent 26rem), linear-gradient(145deg, #eef2ee 0%, #e7ece8 100%);
  color: var(--ink);
  display: flex;
  font-family: Pretendard, "Noto Sans KR", "Apple SD Gothic Neo", Arial, sans-serif;
  inset: 0;
  justify-content: center;
  overflow: hidden;
  padding: 1rem;
  position: fixed;
}

.guide-deck {
  aspect-ratio: 297/210;
  background: #fffefb;
  border-radius: 1.1rem;
  box-shadow: 0 26px 80px rgba(24, 43, 34, 0.2), 0 0 0 1px rgba(48, 68, 58, 0.12);
  display: grid;
  grid-template-rows: 4rem minmax(0, 1fr) 4.15rem;
  height: min(100vh - 2rem, (100vw - 2rem) / 1.4142857);
  max-height: calc(100vh - 2rem);
  max-width: calc(100vw - 2rem);
  overflow: hidden;
  position: relative;
  width: min(100vw - 2rem, (100vh - 2rem) * 1.4142857);
}

.deck-header {
  align-items: center;
  background: rgba(255, 254, 251, 0.96);
  box-shadow: 0 1px 0 rgba(44, 67, 55, 0.1);
  display: flex;
  justify-content: space-between;
  padding: 0 1.75rem;
  position: relative;
  z-index: 20;
}

.deck-brand {
  align-items: center;
  display: flex;
  gap: 0.9rem;
  min-width: 0;
}

.deck-brand img {
  display: block;
  height: auto;
  width: 5.4rem;
}

.deck-brand p {
  color: var(--brand);
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  margin: 0;
}

.deck-brand strong {
  display: block;
  font-size: 0.78rem;
  margin-top: 0.18rem;
}

.deck-status {
  align-items: center;
  display: flex;
  gap: 0.7rem;
}

.deck-status > span {
  color: #718078;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.print-button {
  appearance: none;
  background: #eef3ef;
  border: 0;
  border-radius: 0.55rem;
  color: var(--brand-deep);
  cursor: pointer;
  font: inherit;
  font-size: 0.65rem;
  font-weight: 750;
  padding: 0.5rem 0.72rem;
}

.print-button:hover {
  background: #ddebe3;
}

.deck-pages {
  min-height: 0;
  overflow: hidden;
  position: relative;
}

.guide-page {
  inset: 0;
  opacity: 0;
  overflow: hidden;
  padding: 1.55rem 2.05rem 1.25rem;
  pointer-events: none;
  position: absolute;
  transform: translateX(1.6rem) scale(0.992);
  transition: opacity 220ms ease, transform 260ms ease;
  visibility: hidden;
}

.guide-page.is-active {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(0) scale(1);
  visibility: visible;
  z-index: 2;
}

.page-heading {
  align-items: flex-end;
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;
  margin-bottom: 1rem;
  min-height: 4rem;
}

.page-kicker {
  color: var(--brand);
  font-size: 0.59rem;
  font-weight: 850;
  letter-spacing: 0.15em;
  margin: 0;
}

.page-heading h2 {
  color: #10271c;
  font-size: clamp(1.25rem, 2.2vw, 1.8rem);
  font-weight: 770;
  letter-spacing: -0.05em;
  line-height: 1.18;
  margin: 0.34rem 0 0;
}

.page-heading > div > p:last-child {
  color: var(--muted);
  font-size: 0.69rem;
  line-height: 1.55;
  margin: 0.38rem 0 0;
}

.route-chip {
  background: var(--brand-soft);
  border-radius: 999px;
  color: var(--brand);
  flex: 0 0 auto;
  font-size: 0.61rem;
  font-weight: 800;
  padding: 0.46rem 0.72rem;
}

.feature-layout {
  align-items: start;
  display: grid;
  gap: 1.15rem;
  grid-template-columns: minmax(0, 2.18fr) minmax(15.5rem, 0.82fr);
}

.feature-shot {
  background: #ffffff;
  border-radius: 0.72rem;
  box-shadow: 0 0 0 1px rgba(54, 75, 65, 0.14), 0 12px 30px rgba(24, 43, 34, 0.1);
  margin: 0;
  overflow: hidden;
  position: relative;
}

.feature-shot img {
  display: block;
  height: auto;
  width: 100%;
}

.focus-zone {
  background: rgba(13, 122, 90, 0.025);
  border-radius: 0.42rem;
  box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.78), 0 0 0 6px rgba(13, 122, 90, 0.88), 0 8px 18px rgba(9, 82, 60, 0.12);
  height: var(--h);
  left: var(--x);
  pointer-events: none;
  position: absolute;
  top: var(--y);
  width: var(--w);
  z-index: 4;
}

.focus-zone > span {
  align-items: center;
  background: var(--focus);
  border-radius: 999px;
  box-shadow: 0 3px 10px rgba(8, 76, 56, 0.24);
  color: #ffffff;
  display: flex;
  font-size: 0.6rem;
  font-weight: 850;
  height: 1.45rem;
  justify-content: center;
  left: -0.65rem;
  position: absolute;
  top: -0.66rem;
  width: 1.45rem;
}

.feature-notes {
  display: grid;
  gap: 0.62rem;
}

.note-item {
  align-items: flex-start;
  background: #f4f6f3;
  border-radius: 0.72rem;
  display: grid;
  gap: 0.72rem;
  grid-template-columns: 1.7rem minmax(0, 1fr);
  padding: 0.74rem;
}

.note-item > span {
  align-items: center;
  background: var(--brand);
  border-radius: 999px;
  color: #ffffff;
  display: flex;
  font-size: 0.59rem;
  font-weight: 850;
  height: 1.7rem;
  justify-content: center;
  width: 1.7rem;
}

.note-item h3 {
  color: #172a20;
  font-size: 0.75rem;
  font-weight: 760;
  line-height: 1.35;
  margin: 0;
}

.note-item p {
  color: #66726b;
  font-size: 0.62rem;
  line-height: 1.5;
  margin: 0.3rem 0 0;
}

.cover-page {
  background: radial-gradient(circle at 88% 16%, rgba(35, 123, 84, 0.12), transparent 18rem), linear-gradient(135deg, #fffefb 0%, #f3f8f5 100%);
  padding: 2.6rem 3rem;
}

.cover-grid {
  align-items: center;
  display: grid;
  gap: 3rem;
  grid-template-columns: minmax(0, 1.2fr) minmax(20rem, 0.8fr);
  height: 100%;
}

.cover-copy h1 {
  color: #0f3627;
  font-size: clamp(2.15rem, 4.8vw, 3.55rem);
  font-weight: 790;
  letter-spacing: -0.07em;
  line-height: 1.08;
  margin: 0.75rem 0 0;
}

.cover-copy > p:nth-of-type(2) {
  color: #5f6e66;
  font-size: 0.82rem;
  line-height: 1.72;
  margin: 1rem 0 0;
  max-width: 38rem;
}

.cover-guide {
  align-items: center;
  background: #ffffff;
  border-radius: 0.78rem;
  box-shadow: 0 0 0 1px rgba(48, 77, 63, 0.12);
  display: grid;
  gap: 0.75rem;
  grid-template-columns: 4.6rem minmax(0, 1fr);
  margin-top: 1.25rem;
  padding: 0.85rem 1rem;
}

.cover-guide span {
  color: var(--brand);
  font-size: 0.61rem;
  font-weight: 850;
  letter-spacing: 0.08em;
}

.cover-guide p {
  color: #637069;
  font-size: 0.65rem;
  line-height: 1.55;
  margin: 0;
}

.start-button {
  align-items: center;
  appearance: none;
  background: var(--brand);
  border: 0;
  border-radius: 0.68rem;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 760;
  gap: 1.8rem;
  margin-top: 1.05rem;
  padding: 0.7rem 1rem;
}

.start-button:hover {
  background: var(--brand-deep);
}

.scope-panel {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 1rem;
  box-shadow: 0 18px 42px rgba(25, 52, 39, 0.09), 0 0 0 1px rgba(48, 77, 63, 0.1);
  padding: 1.35rem;
}

.scope-title {
  color: var(--brand);
  font-size: 0.66rem;
  font-weight: 850;
  letter-spacing: 0.1em;
  margin: 0 0 0.85rem;
}

.scope-list {
  display: grid;
  gap: 0.58rem;
}

.scope-item {
  align-items: center;
  background: #f5f7f4;
  border-radius: 0.66rem;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: 2rem minmax(0, 1fr);
  padding: 0.7rem;
}

.scope-item > span {
  align-items: center;
  background: var(--brand-soft);
  border-radius: 50%;
  color: var(--brand);
  display: flex;
  font-size: 0.58rem;
  font-weight: 850;
  height: 2rem;
  justify-content: center;
  width: 2rem;
}

.scope-item strong {
  display: block;
  font-size: 0.74rem;
}

.scope-item p {
  color: #6b7770;
  font-size: 0.6rem;
  margin: 0.2rem 0 0;
}

.summary-grid {
  display: grid;
  gap: 1.15rem;
  grid-template-columns: minmax(0, 2.25fr) minmax(16rem, 0.75fr);
}

.summary-table {
  background: #ffffff;
  border-radius: 0.78rem;
  box-shadow: 0 0 0 1px rgba(48, 77, 63, 0.13);
  overflow: hidden;
}

.summary-row {
  align-items: center;
  box-shadow: 0 1px 0 rgba(48, 77, 63, 0.1);
  display: grid;
  gap: 0.8rem;
  grid-template-columns: minmax(11rem, 1.1fr) 7rem minmax(14rem, 1.35fr);
  min-height: 3.25rem;
  padding: 0.68rem 0.9rem;
}

.summary-row:last-child {
  box-shadow: none;
}

.summary-row strong,
.summary-row span,
.summary-row p {
  font-size: 0.64rem;
  line-height: 1.45;
  margin: 0;
}

.summary-row span {
  color: var(--brand);
  font-weight: 780;
}

.summary-row p {
  color: #66726b;
}

.summary-head {
  background: #143f30;
  color: #ffffff;
  min-height: 2.35rem;
}

.summary-head span {
  color: #ffffff;
  font-size: 0.59rem;
  letter-spacing: 0.04em;
}

.summary-aside {
  display: grid;
  gap: 0.75rem;
}

.workflow-card,
.permission-card {
  border-radius: 0.78rem;
  padding: 1rem;
}

.workflow-card {
  background: #143f30;
  color: #ffffff;
}

.workflow-card > p {
  color: #bde0d0;
  font-size: 0.6rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  margin: 0;
}

.workflow-card ol {
  display: grid;
  gap: 0.5rem;
  margin: 0.8rem 0 0;
  padding: 0 0 0 1.1rem;
}

.workflow-card li {
  font-size: 0.66rem;
  line-height: 1.45;
}

.permission-card {
  background: #f2f5f2;
}

.permission-card span {
  color: var(--brand);
  font-size: 0.59rem;
  font-weight: 850;
  letter-spacing: 0.08em;
}

.permission-card h3 {
  font-size: 0.76rem;
  margin: 0.48rem 0 0;
}

.permission-card p {
  color: #68746d;
  font-size: 0.63rem;
  line-height: 1.55;
  margin: 0.4rem 0 0;
}

.deck-controls {
  align-items: center;
  background: #fafbf9;
  box-shadow: 0 -1px 0 rgba(44, 67, 55, 0.1);
  display: grid;
  gap: 0.8rem;
  grid-template-columns: 5.2rem minmax(0, 1fr) 5.2rem;
  padding: 0.58rem 1.2rem;
  position: relative;
  z-index: 20;
}

.deck-arrow {
  align-items: center;
  appearance: none;
  background: #ffffff;
  border: 0;
  border-radius: 0.55rem;
  box-shadow: 0 0 0 1px rgba(48, 77, 63, 0.14);
  color: var(--brand-deep);
  cursor: pointer;
  display: flex;
  font: inherit;
  font-size: 0.64rem;
  font-weight: 760;
  gap: 0.45rem;
  height: 2.45rem;
  justify-content: center;
}

.deck-arrow.is-next {
  background: var(--brand);
  box-shadow: none;
  color: #ffffff;
}

.deck-arrow:disabled {
  cursor: default;
  opacity: 0.28;
}

.page-dots {
  align-items: center;
  display: flex;
  gap: 0.34rem;
  justify-content: center;
  min-width: 0;
}

.page-dot {
  align-items: center;
  appearance: none;
  background: transparent;
  border: 0;
  border-radius: 0.55rem;
  color: #77827c;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  font: inherit;
  gap: 0.08rem;
  min-width: 3.3rem;
  padding: 0.32rem 0.42rem;
}

.page-dot > span {
  align-items: center;
  background: #e6ebe7;
  border-radius: 999px;
  display: flex;
  font-size: 0.56rem;
  font-weight: 800;
  height: 1.18rem;
  justify-content: center;
  width: 1.18rem;
}

.page-dot small {
  font-size: 0.54rem;
  font-weight: 700;
}

.page-dot.is-active {
  background: var(--brand-soft);
  color: var(--brand-deep);
}

.page-dot.is-active > span {
  background: var(--brand);
  color: #ffffff;
}

.page-dot:focus-visible,
.deck-arrow:focus-visible,
.start-button:focus-visible,
.print-button:focus-visible {
  outline: 2px solid #1e8c68;
  outline-offset: 2px;
}

@media (max-width: 900px), (max-height: 620px) {
  .guide-deck {
    border-radius: 0.7rem;
    grid-template-rows: 3.3rem minmax(0, 1fr) 3.5rem;
  }
  .deck-header {
    padding: 0 1rem;
  }
  .deck-brand img {
    width: 4.4rem;
  }
  .guide-page {
    padding: 1rem 1.3rem 0.8rem;
  }
  .page-heading {
    margin-bottom: 0.65rem;
    min-height: 3.2rem;
  }
  .feature-layout {
    gap: 0.8rem;
    grid-template-columns: minmax(0, 2.25fr) minmax(12rem, 0.75fr);
  }
  .note-item {
    gap: 0.5rem;
    grid-template-columns: 1.4rem minmax(0, 1fr);
    padding: 0.5rem;
  }
  .note-item > span {
    height: 1.4rem;
    width: 1.4rem;
  }
  .page-dot {
    min-width: 2.5rem;
  }
}
@page {
  margin: 0;
  size: A4 landscape;
}
@media print {
  :host {
    height: auto;
    overflow: visible;
  }
  .feature-guide {
    background: #ffffff;
    display: block;
    inset: auto;
    overflow: visible;
    padding: 0;
    position: static;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
  .guide-deck {
    background: #ffffff;
    border-radius: 0;
    box-shadow: none;
    display: block;
    height: auto;
    max-height: none;
    max-width: none;
    overflow: visible;
    width: auto;
  }
  .deck-header,
  .deck-controls {
    display: none !important;
  }
  .deck-pages {
    overflow: visible;
    position: static;
  }
  .guide-page,
  .guide-page.is-active {
    break-after: page;
    height: 210mm;
    inset: auto;
    opacity: 1;
    overflow: hidden;
    padding: 12mm;
    page-break-after: always;
    pointer-events: auto;
    position: relative;
    transform: none;
    transition: none;
    visibility: visible;
    width: 297mm;
  }
  .guide-page:last-child {
    break-after: auto;
    page-break-after: auto;
  }
}`],
})
export class PageHtmlComponent implements OnInit {
    public currentPage: number = 0;
    public readonly pages: Array<{ title: string; short: string }> = [
        { title: '안내서 소개', short: '소개' },
        { title: '홈', short: '홈' },
        { title: '업무 카테고리', short: '사건' },
        { title: '고객리스트', short: '고객' },
        { title: '상담 및 접속현황', short: '상담' },
        { title: '내 정보 프로필', short: '프로필' },
        { title: 'IP 데이터 Excel Import', short: 'Excel' },
        { title: '전체 요약', short: '요약' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public get totalPages(): number {
        return this.pages.length;
    }

    public async goToPage(index: number) {
        const target = Math.max(0, Math.min(index, this.totalPages - 1));
        if (target === this.currentPage) return;
        this.currentPage = target;
        await this.service.render();
    }

    public async previousPage() {
        await this.goToPage(this.currentPage - 1);
    }

    public async nextPage() {
        await this.goToPage(this.currentPage + 1);
    }

    public printGuide() {
        window.print();
    }

    @HostListener('window:keydown', ['$event'])
    public async onKeydown(event: KeyboardEvent) {
        if (event.key === 'ArrowRight' || event.key === 'PageDown') {
            event.preventDefault();
            await this.nextPage();
        }
        if (event.key === 'ArrowLeft' || event.key === 'PageUp') {
            event.preventDefault();
            await this.previousPage();
        }
        if (event.key === 'Home') {
            event.preventDefault();
            await this.goToPage(0);
        }
        if (event.key === 'End') {
            event.preventDefault();
            await this.goToPage(this.totalPages - 1);
        }
    }
}

export default PageHtmlComponent;